export interface IMarketingCampaing {
    id: string
    name: string
    bot_id: string
    invitation_id: string | null
    start_date: string
    end_date: string
    prizes: {
        id: string, 
        amount: number
        place: number
    }[]
    limit: number
    events: MarketingEvents[]
    total_activated: number
    is_finished: boolean
    is_active: boolean
    is_draw: boolean
    auto_post_channel: number | null
    auto_post_results: boolean
}

export interface IListMarketingCampaignResults {
    items: IMarketingCampaing[]
    totalPages: number
}

export interface ICreateMarketingCampaign {
    name: string
    invitation_id?: string
    start_date: string
    end_date: string
    prizes: {
        id: string, 
        amount: number
        place: number
    }[]
    is_draw: boolean
    channels: number[]
    limit: number
    events: MarketingEvents[]
    auto_post_channel?: number
    auto_post_results: boolean
}

export const MarketingEvents = {
    InvitationActivated: "InvitationActivatedDomainEvent",
    UserRegistered: "UserRegisteredDomainEvent"
} as const

export type MarketingEvents = typeof MarketingEvents[keyof typeof MarketingEvents]

export interface IChannel {
    id: string
    name: string
    telegramId: number
}

export interface IMarketingCampaignStatistics {
    channelId: number
    transitions: number
}

export const PrizeStatus = {
    error: "error",
    waiting: "waiting",
    success: "success"
} as const

export type PrizeStatus = typeof PrizeStatus[keyof typeof PrizeStatus]

export interface IPrize {
    id: string
    place: number
    status: PrizeStatus
    user?: {
        id: string
        username: string | null
        name: string | null
        telegram_id: string
    }
    bonus_id: string
    amount: number
}

export interface IListPrizesResult {
    totalPages: number
    items: IPrize[]
}

export interface IParticipation {
    id: string
    marketing_campaign_id: string
    user?: {
        id: string
        username: string | null
        name: string | null
        telegram_id: string
        phone: string | null
    }
}

export interface IListParticipationsResult {
    totalPages: number
    items: IParticipation[]
}